export default __webpack_public_path__ + "static/media/5329@3x.b2ea04e0.webp";